import styled from 'styled-components'
import Image from 'next/image'
import { mq, sizes } from 'src/theme'

import A from '../A'
import Icon from '../Icon'
import { WysiwygContainer } from '../WysiwygRenderer/styled'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border: 1px solid ${({ theme }) => theme.colors.greyA5};
  padding: 1rem;

  @media ${mq(sizes.desktop)} {
    display: none;
  }
`

export const ImageWrapper = styled.div`
  margin: 2rem auto;
`

export const StyledImage = styled(Image)`
  position: relative;
`

export const Text = styled.div`
  text-align: center;
  ${({ theme }) => theme.textStyles.text_16};
`

export const CTA = styled(A)`
  margin: 2rem auto;
  padding-bottom: 0.5rem;
  ${({ theme }) => theme.textStyles.text_16};
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
`

export const CloseButton = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid ${({ theme }) => theme.colors.greyCE};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  cursor: pointer;
  & svg {
    width: 1.75rem;
    height: 1.75rem;
    color: ${({ theme }) => theme.colors.pureBlack};
  }
`

export const Tuto = styled(WysiwygContainer)`
  margin-top: 0.5rem;
  max-width: 100%;

  ol {
    padding-left: 2.5rem;
  }

  li {
    margin-bottom: 1rem;
  }

  h2 {
    text-align: center;
    ${({ theme }) => theme.textStyles.text_bold_16};

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.text_bold_32};
    }
  }

  @media ${mq(sizes.desktop)} {
    margin-top: 1.5rem;
  }
`
